import { post, put, get } from "../../helpers/apihelpers";

export const CreateSubscriptionService=async(data)=>{
    try {
        const result = await post(`api/admin/subscribe_points/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateSubscriptionService=async(data,id)=>{
    try {
        const result = await put(`api/admin/subscribe_points/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetSubscriptionService = async ()=>{
  try {
    const result = await get(`api/admin/subscribe_points/get`);
    return result;
  } catch (err) {
    return err.response;
  }
}